import styled from "styled-components";
import Spacing from "../style/tokens/Spacing";

export const StyledPasswordResetForm = styled.div`
  margin: auto;
  max-width: 20rem;
  padding ${Spacing.loose};
  padding-top: 5rem;
`;
